import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../Button/BackButton";
import {
  FAQWrapper,
  FAQTopBar,
  FAQTopBarTitle,
  FAQList,
  FAQItem,
  FAQQuestion,
  FAQAnswer,
  FAQChevron,
} from "./styles.bids";

const FAQS = [
  {
    q: "How do bids work?",
    a: "Hyperpure sends out bids for products it needs. As a vendor, you can view open bids, submit your best pricing, and if selected, you'll be awarded the contract. The entire process happens within the app.",
  },
  {
    q: "Can I schedule a delivery for later?",
    a: "Yes! Each bid has a specific delivery window mentioned on the bid card (e.g., 1 Apr – 31 May). Once you're awarded a bid, deliveries are scheduled within that window as per the purchase order.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Hyperpure processes payments directly to your registered bank account. All payments are made post-delivery and verification as per the agreed payment cycle.",
  },
  {
    q: "How do I track my order?",
    a: "Once a bid is awarded and a purchase order is created, you can track all deliveries and their statuses from the PO section of the app.",
  },
  {
    q: "What is your refund policy?",
    a: "In case of a bid cancellation or quality dispute, refunds are processed within 5–7 working days. Any processing fee or security deposit paid is refunded as per the terms agreed at the time of bid submission.",
  },
  {
    q: "How do I contact customer support?",
    a: "You can reach our support team directly from any bid or order screen by tapping the call icon at the top right. Our team is available Monday–Saturday, 9 AM to 8 PM.",
  },
  {
    q: "Are there any discounts for students?",
    a: "Our vendor bidding platform is designed for registered businesses. However, if you're a student running a registered business, you're welcome to participate like any other vendor.",
  },
  {
    q: "Do you offer catering services?",
    a: "Hyperpure focuses on supplying fresh produce, dairy, and pantry staples to restaurants, hotels, and food businesses. We don't directly offer catering, but our vendors may supply to catering businesses.",
  },
];

const BidsFAQ = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <FAQWrapper>
      <FAQTopBar>
        <BackButton pathName="/bids/all" />
        <FAQTopBarTitle>FAQ</FAQTopBarTitle>
      </FAQTopBar>

      <FAQList>
        {FAQS.map((faq, i) => (
          <FAQItem key={i}>
            <FAQQuestion onClick={() => toggle(i)}>
              <span>{faq.q}</span>
              <FAQChevron $open={openIndex === i}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4 6l4 4 4-4" stroke="#aaa" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </FAQChevron>
            </FAQQuestion>
            {openIndex === i && <FAQAnswer>{faq.a}</FAQAnswer>}
          </FAQItem>
        ))}
      </FAQList>
    </FAQWrapper>
  );
};

export default BidsFAQ;
